export default "__VITE_ASSET__BIC1YUd8__"